//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'ISTH_DIC_non_overt',
  data() {
    return {
      defaultJson:{
        "Low protein C": "蛋白 C 降低",
        "Elevated Fibrin-related marker": "纤维蛋白相关标记物升高",
        "Platelet count": "血小板计数",
        "Prothrombin trend": "凝血酶原趋势",
        "Underlying disorder associated with DIC": "与 DIC 相关的潜在异常",
        "fibrin marker hint": "例如可溶性纤维蛋白单体火纤维蛋白降解产物",
        "Fibrin-related markers trend": "纤维蛋白相关标记物趋势",
        "Low antithrombin": "抗凝血酶降低",
        "Prothrombin time": "凝血酶原时间",
        "underlying hint": "患者是否存在与 DIC 相关的潜在异常？",
        "Precondition": "先决条件",
        "Major Criteria": "主要标准",
        "Platelet trend": "血小板趋势",
        "Specific Criteria": "特异性标准"
      },
      form:{
        precond:'0',

        plate_count:'',
        plate_trend:'1',
        pt_time:'',
        pt_trend:'1',
        marker:'0',
        marker_trend:'1',

        antithromb:'0',
        prot_c:'0',
      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"-1",name:'➚'},
        {value:"0",name:'='},
        {value:"1",name:'➘'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // precond * 2+ ((plate_count > 100) ? 0 : 1)+ plate_trend + ((pt_time > 3) ? 1 : 0) + pt_trend + marker + marker_trend + (antithromb ? 1 : -1)	+ (prot_c ? 1 :-1)
        let result = form.precond * 2+ ((form.plate_count > 100) ? 0 : 1)+ form.plate_trend + ((form.pt_time > 3) ? 1 : 0) + form.pt_trend + form.marker + form.marker_trend + (form.antithromb ? 1 : -1)	+ (form.prot_c ? 1 :-1)
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/ISTH_DIC_non_overt.vue